import api from '../api';

const presenceService = {
  heartbeat: (data, config = {}) => api.post('/talk/presence', data, {
    skipErrorToast: true, timeout: 10000, ...config,
  }),
  statuses: (userIds, config = {}) => api.get('/talk/presence', {
    params: { user_ids: userIds }, skipErrorToast: true, timeout: 10000, ...config,
  }),
};

export default presenceService;
